import React from "react";
import { Card } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";

const DiskHealth = ({ health }) => {
  const free = health?.freeMB ?? 0;
  const total = health?.totalMB ?? 0;
  const used = total - free;

  const data = {
    labels: ["Used MB", "Free MB"],
    datasets: [
      {
        data: [used, free],
        backgroundColor: ["#FF6384", "#36A2EB"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: { position: "bottom" },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw;
            return `${label}: ${value.toLocaleString()} MB`;
          },
        },
      },
    },
  };

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Disk</Card.Title>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center align-items-center">
        <div style={{ width: "250px" }}>
          <Doughnut data={data} options={options} />
        </div>
      </Card.Body>
      <Card.Footer>
        <small className="d-flex">
          Status:{" "}
          <div
            className={`ms-2 me-2 circle ${
              health.status === "UP"
                ? "pulse green"
                : health.status === "DOWN"
                ? "red"
                : health.status === "WARN"
                ? "yellow"
                : "blue"
            }`}
          ></div>{" "}
          | Free: {free.toLocaleString()} MB / Total: {total.toLocaleString()}{" "}
          MB
        </small>
      </Card.Footer>
    </Card>
  );
};

export default DiskHealth;
